// Modules
import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { motion } from "framer-motion";
// Utils
import convertNumbersToEnglish from "../../../Utils/convertNumbersToEnglish";
// Components
import Header from "../../Common/Header/Header";
import SideBar from "../../Common/SideBar/SideBar";
import LandingContent from "../../Contents/LandingContent/LandingContent";
import ImageArticles from "../../Contents/ImageArticles/ImageArticles";
import Books from "../../Contents/Books/Books";
import Mybooks from "../../Contents/MyBooks/Mybooks";
import Footer from "../../Common/Footer/Footer";
import ContactUs from "../../Contents/ContactUs/ContactUs";
import AboutUs from "../../Contents/AboutUs/AboutUs";
import Filtering from "../../Common/Filtering/Filtering";
import Journal from "../../Contents/Journal/Journal";
import JournalCard from "../../Common/Card/JournalCard/JournalCard";
// import QuarterlyCard from "../../Common/Card/QuarterlyCard/QuarterlyCard";
import Quarterlys from "../../Contents/Quarterlys/Quarterlys";
// Styles
import Styles from "./Styles/Landing.module.css";
// Images
import whiteSortNew from "../../../Assets/Icons/white-sort-new.png";
import darkSortNew from "../../../Assets/Icons/dark-sort-new.png";
import whiteSortOld from "../../../Assets/Icons/white-sort-old.png";
import darkSortOld from "../../../Assets/Icons/dark-sort-old.png";
import whiteSortview from "../../../Assets/Icons/white-sort-view.png";
import darkSortview from "../../../Assets/Icons/dark-sort-view.png";
import whiteSortlongest from "../../../Assets/Icons/white-sort-longest.png";
import darkSortlongest from "../../../Assets/Icons/dark-sort-longest.png";
import whiteSortshortest from "../../../Assets/Icons/white-sort-shortest.png";
import darkSortshortest from "../../../Assets/Icons/dark-sort-shortest.png";
import whiteSortsuggested from "../../../Assets/Icons/white-suggested-sort.png";
import darkSortsuggested from "../../../Assets/Icons/dark-suggested-sort.png";
import deleteFilters from "../../../Assets/Icons/close.png";
// API
import { getArticles } from "../../../Services/getData";
import { saveArticle } from "../../../Services/usersService";
// Context
import { AuthContext } from "../../../Context/AuthContext";
import ImageArticlesListCard from "../../Common/Card/ImageArticlesListCard/ImageArticlesListCard";

const Landing = () => {
  const { location } = useHistory();
  const { isLoggedIn } = useContext(AuthContext);
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [activeFilter, setActiveFilter] = useState(["newest"]);

  useEffect(() => {
    const api = async () => {
      try {
        if (location.pathname === "/image-articles") {
          const { data } = await getArticles("visual");
          setItems(
            data.article.sort((a, b) => new Date(b.date) - new Date(a.date))
          );
          setFilteredItems(
            data.article.sort((a, b) => new Date(b.date) - new Date(a.date))
          );
        } else if (location.pathname === "/journal") {
          const { data } = await getArticles("textual");
          setItems(
            data.article.sort((a, b) => new Date(b.date) - new Date(a.date))
          );
          setFilteredItems(
            data.article.sort((a, b) => new Date(b.date) - new Date(a.date))
          );
        }
        // else if (location.pathname === "/image-articles") {
        //   const { data } = await getArticles("quarterly");
        //   setItems(
        //     data.article.sort((a, b) => new Date(b.date) - new Date(a.date))
        //   );
        //   setFilteredItems(
        //     data.article.sort((a, b) => new Date(b.date) - new Date(a.date))
        //   );
        // }
      } catch (ex) {
        // toast.error(ex.response.data.message);
        setItems([]);
      }
    };

    api();
  }, [location]);

  const handleChangePosts = (post) => {
    const copyItems = [...items];
    const filteredItems = copyItems.filter((i) => i.category === post.category);
    setFilteredItems(filteredItems);
    toast.success(
      `لیست مقالات ${post.kind === "textual" ? "متنی" : "تصویری"} بر اساس ${
        post.category
      } بروزرسانی شد`
    );
    return;
  };

  const handleShareArticle = (address) => {
    navigator.clipboard
      .writeText(address)
      .then(() => {
        toast.success(
          "آدرس مقاله در کلیپبورد شما ذخیره شد میتوانید به اشتراک بگذارید"
        );
      })
      .catch((err) => {
        toast.error("خطا در ذخیره آدرس در کلیپبورد:", err);
      });
  };

  const handleSaveArticle = (articleId) => {
    const data = { articleId };
    if (isLoggedIn) {
      toast.promise(saveArticle(data), {
        loading: "در حال ذخیره سازی مقاله . . .",
        success: (res) => res.data.message,
        error: (res) => res.response.data.message,
      });
      return;
    }
    toast.error("برای ذخیره مقاله ابتدا وارد حساب کاربری خود شوید");
  };

  const handleFiltering = (filterKind) => {
    if (!activeFilter.includes(filterKind)) {
      const copyItems = [...items];
      if (filterKind === "newest") {
        const newItems = copyItems.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setFilteredItems(newItems);
        toast.success("بروزرسانی بر اساس جدیدترین");
      } else if (filterKind === "oldest") {
        const newItems = copyItems.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
        setFilteredItems(newItems);
        toast.success("بروزرسانی بر اساس قدیمی ترین");
      } else if (filterKind === "view") {
        const newItems = copyItems.sort(
          (a, b) => b.views.count - a.views.count
        );
        setFilteredItems(newItems);
        toast.success("بروزرسانی بر اساس بیشترین بازدید");
      } else if (filterKind === "longest") {
        const newItems = copyItems.sort(
          (a, b) =>
            +convertNumbersToEnglish(b.wordsCount.split(" ")[0].toString()) -
            +convertNumbersToEnglish(a.wordsCount.split(" ")[0].toString())
        );
        setFilteredItems(newItems);
        toast.success("بروزرسانی بر اساس طولانی ترین");
      } else if (filterKind === "shortest") {
        const newItems = copyItems.sort(
          (a, b) =>
            +convertNumbersToEnglish(a.wordsCount.split(" ")[0].toString()) -
            +convertNumbersToEnglish(b.wordsCount.split(" ")[0].toString())
        );
        setFilteredItems(newItems);
        toast.success("بروزرسانی بر اساس کوتاه ترین");
      } else if (filterKind === "suggested") {
        const newItems = copyItems.filter((i) => i.isSuggested === true);
        if (newItems.length === 0) {
          toast.error("مقاله ای بر اساس این فیلتر وجود ندارد");
          return;
        }
        setFilteredItems(newItems);
        toast.success("بروزرسانی بر اساس پیشنهاد هرمه");
      }
      setActiveFilter(filterKind);
      return;
    }
    toast.error("لطفا از فیلتر های غیرفعال استفاده کنید");
  };

  return (
    <>
      <div className={Styles.container}>
        <Toaster
          toastOptions={{
            duration: 2000,
            style: {
              background: "#363636",
              color: "#fff",
            },
          }}
        />
        {/* Header */}
        <Header />
        {/* Content */}
        <div className={Styles.content}>
          {/* Posts */}
          {location.pathname === "/" && <LandingContent />}
          {location.pathname === "/image-articles" && (
            <ImageArticles
              handleSaveArticle={handleSaveArticle}
              handleShareArticle={handleShareArticle}
            />
          )}
          {location.pathname === "/journal" && (
            <Journal
              handleSaveArticle={handleSaveArticle}
              handleShareArticle={handleShareArticle}
            />
          )}
          {location.pathname === "/quarterly" && <Quarterlys />}
          {location.pathname === "/library" && <Books />}
          {location.pathname === "/library/my-books" && <Mybooks />}
          {location.pathname === "/contact-us" && <ContactUs />}
          {location.pathname === "/about-us" && <AboutUs />}
          {/* Sidebar */}
          <SideBar />
        </div>
      </div>
      {/* Lists */}
      {location.pathname !== "/" &&
        location.pathname !== "/library" &&
        location.pathname !== "/library/my-books" &&
        location.pathname !== "/contact-us" &&
        location.pathname !== "/about-us" &&
        items.length > 0 && (
          <div className={Styles.listsContainer}>
            <motion.div className={Styles.filteringContainer}>
              <h3 className={Styles.filteringTitle}>مرتب سازی بر اساس :</h3>
              <Filtering
                activeFilter={activeFilter}
                filterKind="newest"
                darkIcon={darkSortNew}
                whiteIcon={whiteSortNew}
                filterName="جدیدترین"
                handleFiltering={handleFiltering}
              />
              <Filtering
                activeFilter={activeFilter}
                filterKind="oldest"
                darkIcon={darkSortOld}
                whiteIcon={whiteSortOld}
                filterName="قدیمی ترین"
                handleFiltering={handleFiltering}
              />
              <Filtering
                activeFilter={activeFilter}
                filterKind="view"
                darkIcon={darkSortview}
                whiteIcon={whiteSortview}
                filterName="بیشترین بازدید"
                handleFiltering={handleFiltering}
              />
              {location.pathname === "/journal" && (
                <>
                  <Filtering
                    activeFilter={activeFilter}
                    filterKind="longest"
                    darkIcon={darkSortlongest}
                    whiteIcon={whiteSortlongest}
                    filterName="طولانی ترین"
                    handleFiltering={handleFiltering}
                  />
                  <Filtering
                    activeFilter={activeFilter}
                    filterKind="shortest"
                    darkIcon={darkSortshortest}
                    whiteIcon={whiteSortshortest}
                    filterName="کوتاه ترین"
                    handleFiltering={handleFiltering}
                  />
                </>
              )}
              <Filtering
                activeFilter={activeFilter}
                filterKind="suggested"
                darkIcon={darkSortsuggested}
                whiteIcon={whiteSortsuggested}
                filterName="پیشنهاد هرمه"
                handleFiltering={handleFiltering}
              />
              {activeFilter.length !== 1 && (
                <div
                  className={Styles.deleteFilters}
                  onClick={() => {
                    setActiveFilter(["newest"]);
                    setFilteredItems([...items]);
                    toast.success("فیلتر ها با موفقیت حذف شدند");
                  }}
                >
                  <img src={deleteFilters} alt="" />
                </div>
              )}
            </motion.div>
            <div className={Styles.lists}>
              {location.pathname === "/image-articles" &&
                filteredItems.map((item, index) => (
                  <div key={index} className={Styles.visualsListsContainer}>
                    <ImageArticlesListCard
                      handleShareArticle={handleShareArticle}
                      item={item}
                      isList={true}
                      handleChangePosts={handleChangePosts}
                      handleSaveArticle={handleSaveArticle}
                    />
                  </div>
                ))}
              {location.pathname === "/journal" &&
                filteredItems.map((item, index) => (
                  <div key={index} className={Styles.journalListsContainer}>
                    <JournalCard
                      handleShareArticle={handleShareArticle}
                      item={item}
                      isList={true}
                      handleChangePosts={handleChangePosts}
                      handleSaveArticle={handleSaveArticle}
                    />
                  </div>
                ))}
              {/* {location.pathname === "/quarterly" &&
                filteredItems.map((item, index) => (
                  <div key={index} className={Styles.quarterlyListsContainer}>
                    <QuarterlyCard isList={true} item={item} />
                  </div>
                ))} */}
              <div className={Styles.footer}>
                <Footer />
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default Landing;
